<template>
    <div id="app" style="overflow: hidden;">
        
        <router-view  v-if="pedidoParadoBuscado == null && loadingPedidoParado == false"/>


        <!-- caso esteja no loading de enviar pedido (depois e o pagamento pix ter sido feito) -->
        <div v-if="loadingPedidoParado == true" class="center img-loading-container">
            <img src="./assets/loading.gif" alt="" class="img-loading">
        </div>

    </div>
</template>

<script>
import { apiFechouTelaConta } from './api/ApiPegarMesa';


export default {
    data() {
        return {
            loadingPedidoParado: false,
            pedidoParadoBuscado: null,
            fontLoaded: false,
        };
    },
    created() {
        this.checarMinimizado();
        this.checarPedidoParadoBalcao();
    },

    components: {},
    methods: { 

        
        checarMinimizado() {
            document.addEventListener("visibilitychange", () => {
                if (document.hidden) {
                    console.log("Browser minimizado")
                    if (document.URL.includes("conta") ) {
                        console.log("%c MINIMIZANDO CONTA", "background: yellow")
                        let json = {
                            cnpj: this.$store.state.cnpj,
                            idTerminal: this.$store.state.idTerminal,
                            operacao: 24, // operacao de desbloqueio
                            NumeroCMS_FK: this.$store.state.mesa,
                            mesa: this.$store.state.mesa,
                            // tipo: this.motivo,
                            IdGarcons_FK: this.$store.state.idgarcom,
                            CodigoCentroResultado_FK: this.$store.state.codigoCentroResultado,
                            idCaixaLio: this.$store.state.idTerminal,
                            numeroEmpresaFK: this.$store.state.numeroEmpresaFK
                        }
                        apiFechouTelaConta(json).then((res) => {
                            console.log(res)
                            
                            this.$router.push({path: "/cardapio"})
                        })
                    } 
                } else {
                    console.log("Browser aparente")
                       if (document.URL.includes("conta") ) {
                        console.log("%c MOSTRANDO TELA CONTA", "background: rgb(255, 100, 100)")
                    } 
                }
            })
        },



        checarPedidoParadoBalcao() {
            if (this.$store.state.tipoCardapio === 'balcao') {
                const ultimoPedidoBalcao =  localStorage.getItem("ultimoPedidoBalcao") 
                if (ultimoPedidoBalcao) {

                    /**
                     * O tipo vai ser
                     * {
                            telefone : this.telefone,
                            pix_qr_code: this.pix_qr_code,
                            pix_qr_code_horario: this.pix_qr_code_horario, // esse aqui serve pra mandar pro BalcaoStatusView ja que la vai ter o MpStatusScreenPix que exite esse horario formatado 
                            horario: new Date() // esse aqui serve pra calculos no front pra saber se devemos mostrar o qr code ou não, já que ele tem validade
                        }
                     * @type {Object}
                     */
                    this.pedidoParadoBuscado = JSON.parse(ultimoPedidoBalcao)
                    console.log("%c PEDIDO PARADO ENCONTRADO", "background: red; color: white; padding: 5px")
                    console.log(this.pedidoParadoBuscado)

                    // verifica se o pedido parado encontrado ainda é valido (se o horario atual for menor que o horario do pedido + 60 minutos)
                    const horarioPedido = new Date(this.pedidoParadoBuscado.horario);
                    const horarioAtual = new Date();
                    const diffMinutos = (horarioAtual - horarioPedido) / 1000 / 60;
                    if (diffMinutos > 60) {
                        console.log("%c PEDIDO PARADO ENCONTRADO MAS EXPIRADO", "background: orange; color: white; padding: 5px")
                        localStorage.removeItem("ultimoPedidoBalcao");
                        this.pedidoParadoBuscado = null;
                    } else {
                        console.log("%c PEDIDO PARADO ENCONTRADO E VALIDO", "background: green; color: white; padding: 5px")
                        this.$router.push({
                            path: "/balcaostatus",
                            query: {
                                telefone : this.pedidoParadoBuscado.telefone,
                                pix_qr_code: this.pedidoParadoBuscado.pix_qr_code,
                                pix_qr_code_horario: this.pedidoParadoBuscado.pix_qr_code_horario,
                            },
                        });
                    }
                    
                } else {
                    console.log("%c NENHUM PEDIDO PARADO ENCONTRADO", "background: green; color: white; padding: 5px")
                }
            }
        },

        
    },
};
</script>

<style>
</style>
